// A document category's display name (emr_category) is NOT unique within an
// organization: the uniqueness constraint is scoped to [organization_id, ai_tag]
// (see app/models/document_category.rb), so the global AI-category catalog can
// legitimately map several distinct catalog entries onto one EMR folder name
// (e.g. "Clearance" and "FMLA / Disability" both under "Admin - Signed Forms &
// Letters"). Category <Select>s use emr_category as the option `value`, and
// AntD's virtualized dropdown keys options by value — duplicate values collide
// on scroll and the list collapses into repeated entries. Dedupe by
// category name (keeping the first occurrence) before building options so each
// value appears once. Non-empty names only; blank names can't be a usable option
// value. Most callers receive model-shaped rows with `emr_category`; normalized
// API option shapes can supply an accessor for their value field.
const dedupeDocumentCategories = (
  categories,
  getName = (category) => category && category.emr_category,
) => {
  const seen = new Set();
  return (categories || []).filter((category) => {
    const name = getName(category);
    if (!name || seen.has(name)) return false;
    seen.add(name);
    return true;
  });
};

export default dedupeDocumentCategories;
